<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <router-link
              :to="{ path: '/FAQ/Create' }"
              class="vs-component vs-button bg_l_green"
              v-has-permission="permission267"
            >
              <feather-icon
                icon="PlusIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />{{ $t("CreateNewFAQ") }}
            </router-link>
            <div class="fleft">
              <router-link
                :to="{ path: '/FAQ/FAQCategory/Index' }"
                class="vs-component vs-button bg_l_blue mr-4"
              >
                <feather-icon
                  icon="BookIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("FAQCategories") }}
              </router-link>
              <vs-button
                @click="showFilters = !showFilters"
                class="bg_purple mr-4"
              >
                <feather-icon
                  icon="FilterIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Filter") }}
              </vs-button>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <form v-if="showFilters" class="filter-form">
              <div class="vx-row mb-6">
                <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
                  <label class="vs-select--label mb-1">{{
                    $t("FAQCategory")
                  }}</label>
                  <v-select
                    label="name"
                    :options="allFAQCats"
                    v-model="gridSearchData.categoryId"
                    :reduce="x => x.id"
                    dir="rtl"
                  >
                  </v-select>
                </div>
                <div class="vx-col lg:w-1/2 sm:w-1/2 w-full mt-4">
                  <vs-button
                    type="filled"
                    class="float-right"
                    @click.prevent="submitFilter()"
                    >{{ $t("SubmitFilter") }}</vs-button
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Question'), sort: 'Question' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('IsActive') },
                { title: $t('Action') }
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 24%">
                  {{ row.question }}
                </td>
                <td style="width: 24%; direction: ltr">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
                <td style="width: 24%">
                  <vs-checkbox v-model="row.isActive" :disabled="true">{{
                    $t("Active")
                  }}</vs-checkbox>
                </td>
                <td style="width: 24%">
                  <router-link :to="{ path: '/FAQ/Modify/' + row.id }">
                    <vs-button
                      radius
                      color="success"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="ml-4 d-inline"
                      v-has-permission="permission266"
                    ></vs-button>
                  </router-link>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteFAQ(row.id)"
                    class="d-inline"
                    v-has-permission="permission268"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.con-vs-checkbox {
  display: inline-flex;
  margin: 0px !important;
}
.filter-form {
  border-top: 1px dashed #ddd;
  padding-top: 0.5rem;
}
.filter-form
  .vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
  padding: 0.5rem 2rem;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";

export default {
  name: "Content_management_FAX_Index",
  data() {
    return {
      permission266: "ModifyFaq",
      permission267: "CreateFaq",
      permission268: "DeleteFaq",
      gridDataSource: {
        type: "app",
        service: "CMS/api/FaqsQuery"
      },
      gridSearchData: {
        keyword: ""
      },
      showFilters: false
    };
  },
  mounted() {
    this.fetchFAQCats();
  },
  computed: {
    ...mapGetters({
      allFAQCats: "FAQcategory/list"
    })
  },
  methods: {
    ...mapActions({
      fetchFAQCats: "FAQcategory/fetch",
      removeFAQ: "FAQ/remove"
    }),
    deleteFAQ(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر"
      }).then(result => {
        if (result.value) {
          this.removeFAQ(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    submitFilter() {
      this.$refs.grid.renderGrid();
    }
  },
  components: {
    "v-select": vSelect,
    DataGrid
  }
};
</script>
